import { useEffect } from "react";

type LoadGoogleMapsProps = {
  onLoad: () => void;
};
export default function LoadGoogleMaps({ onLoad }: LoadGoogleMapsProps) {
  useEffect(() => {
    if ((window as any).google) {
      onLoad();
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyA8hu2yiw1DZ0uesQ2Culbt55GgqAEiAPo&libraries=places`;
    script.async = true;
    script.onload = onLoad;
    document.body.appendChild(script);
  }, [onLoad]);

  return null; // this component just loads the script
}
